exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu_overlay {\n    background: unset;\n}\n.menu_item {\n    height: 35px;\n    line-height: 35px;\n    border: solid 1px #f5f5f5;\n    border-width: 0 0 1px 0;\n}\n.menu_1 {\n    position: fixed;\n    top: 50px;\n    left: 50vw;\n    width: 45vw;\n    -webkit-box-shadow: 1px 1px 5px 3px #e6e9da;\n            box-shadow: 1px 1px 5px 3px #e6e9da;\n    background: white;\n    border-radius: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15ecfc34","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketDetailMenu.vue
// module id = 621
// module chunks = 75